<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.adminUser')"
    resource="admin_users"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/admin_users.js';
import { TOKEN_STORAGE_KEY } from '@/constants'
import _ from 'lodash';

@Component
export default class AdminUsers extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'email_cont',
      'admin_users_roles_role_kind_eq'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'email',
      'user',
      'role',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'admin_users.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: '模拟登陆',
          can: 'admin_users.mock_login',
          type: 'primary'
        },
        on: {
          confirm: async () => {
            const { user, token } = await this.$autoLoading(this.$request.post(`/admin_users/${row.id}/mock_login`));
            localStorage.setItem(TOKEN_STORAGE_KEY, token);
            localStorage.setItem('currentRoleId', _.get(user.current_role, 'id'));

            this.$message.success('模拟登陆成功');
            location.replace(this.$router.resolve({ name: 'home' }).href)
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'admin_users.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/admin_users',
    name: 'admin_users.index',
    component: AdminUsers,
    props: {
      type: 'index',
    }
  },
  {
    path: '/admin_users/new',
    name: 'admin_users.new',
    component: AdminUsers,
    props: {
      type: 'new',
    }
  },
  {
    path: '/admin_users/:id',
    name: 'admin_users.show',
    component: AdminUsers,
    props: {
      type: 'show',
    }
  },
  {
    path: '/admin_users/:id/edit',
    name: 'admin_users.edit',
    component: AdminUsers,
    props: {
      type: 'edit'
    }
  }
]
</script>
